import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useTranslate } from "../../../language/i18n";
import baseStorageService from "../../../services/baseStorage/baseStorageService";
import SelectField from "../SelectField/SelectField";

const LocationSelector = ({ baseStorageId, onSelect, preSelected, disabled, customCssClass, customListCss }) => {
  const translate = useTranslate();
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    if (baseStorageId) {
      baseStorageService
        .getWarehouseLocationsForBaseStorage(baseStorageId)
        .then(response => setLocations(response.data));
    } else {
      setLocations([]);
    }
  }, [baseStorageId]);

  useEffect(() => {
    if (locations?.length && !preSelected) {
      const defaultLocation = locations.find(loc => loc.isReturnLocation);
      if (defaultLocation) {
        onSelect(defaultLocation);
      }
    }
  }, [locations, preSelected, onSelect]);

  return (
    <SelectField
      options={
        locations?.length > 0
          ? locations?.map(current => ({
              ...current,
              id: current?.id,
              value: current?.value,
              label: current?.label,
              description: current?.description,
              locationName: `${current?.value} - ${current?.label}`,
            }))
          : []
      }
      customSettings={{ display: "locationName" }}
      label={translate("WAREHOUSE_LOCATION")}
      disabled={disabled}
      customCssClass={customCssClass}
      customListCss={customListCss}
      selectedId={preSelected?.id || preSelected}
      onSelect={onSelect}
      noResultLabel={"LOCATION_MISSING"}
    />
  );
};

LocationSelector.propTypes = {
  baseStorageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
  preSelected: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
  customCssClass: PropTypes.string,
  customListCss: PropTypes.string,
};

export default LocationSelector;
